import { Utils } from '../../../Common/Utils';
import { LabelBodyHeadline, LabelBodySmall } from '../components';
import { ExerciseStatusView } from './ExerciseStatusView';
import { ChevronRightIcon, VideoPlayerIcon } from '../icons';
import { ExerciseDto, ExerciseStatus } from '../interfaces';
import classNames from 'classnames';

type Props = {
    exercise: ExerciseDto;
    onOpenExercise: () => void;
    className?: string;
};

export function SmallVideoCardView({
    exercise,
    onOpenExercise,
    className,
}: Props) {
    const isDisabled = exercise.Status == ExerciseStatus.Blocked;
    const opacity = isDisabled ? 'opacity-60' : null;

    return (
        <div
            className={classNames(
                className,
                'flex cursor-pointer items-center justify-between',
            )}
            onClick={() => !isDisabled && onOpenExercise()}
        >
            <div className={classNames(opacity, 'flex')}>
                <div className="rounded-[20px] bg-dark-red-10p p-20">
                    <VideoPlayerIcon />
                </div>
                <div className="ml-20 flex flex-col justify-center">
                    <LabelBodyHeadline>{exercise.Name}</LabelBodyHeadline>
                    <div className="flex justify-between">
                        <LabelBodySmall>
                            {Utils.formatTimespan(
                                exercise.VideoMetadata.Duration,
                            )}{' '}
                            min
                        </LabelBodySmall>
                    </div>
                </div>
            </div>
            <div className="flex flex-row">
                <ExerciseStatusView
                    hasLoggedData={false}
                    status={exercise.Status}
                    isVideo={exercise.VideoMetadata != null}
                />
                <ChevronRightIcon className={classNames(opacity, 'ml-20')} />
            </div>
        </div>
    );
}
